export const MAX_LEVEL = 12

const XP_THRESHOLDS = [0, 20, 40, 75, 150, 300, 500, 750, 1000, 1250, 1500, 2000] as const

export function getStudentLevel (xp: number): number {
  for (let i = XP_THRESHOLDS.length - 1; i >= 0; i--) {
    if (xp >= XP_THRESHOLDS[i]) {
      return i + 1
    }
  }
  return 1
}

export function getXPThresholdForLevel (level: number): number {
  return XP_THRESHOLDS[level - 1] ?? 0
}
